import { freeze as y } from "./highrise1747.mjs";
var u = function() {
  function h(t, i, o, e) {
    return this.x = t, this.y = i, this.width = o, this.height = e, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, y(this);
  }
  return h.prototype.toJSON = function() {
    var t = this, i = t.x, o = t.y, e = t.top, r = t.right, s = t.bottom, f = t.left, n = t.width, p = t.height;
    return { x: i, y: o, top: e, right: r, bottom: s, left: f, width: n, height: p };
  }, h.fromRect = function(t) {
    return new h(t.x, t.y, t.width, t.height);
  }, h;
}();
export {
  u as DOMRectReadOnly
};
